import React, { useState } from 'react';

import CustomButton from '../CustomButton';

export interface FilterDrawerActionsProps {
  onSearch: () => void | Promise<void>;
  disabled?: boolean;
}

const FilterDrawerActions: React.FC<FilterDrawerActionsProps> = ({
  onSearch,
  disabled = false,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (disabled || loading) return;
    setLoading(true);
    try {
      await onSearch();
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomButton
      variant="primary"
      fullWidth
      onClick={() => {
        void handleClick();
      }}
      disabled={disabled || loading}
      loading={loading}
    >
      Buscar
    </CustomButton>
  );
};

export default FilterDrawerActions;
